import { render, staticRenderFns } from "./AssistantButtons.vue?vue&type=template&id=3ffbc771"
import script from "./AssistantButtons.vue?vue&type=script&lang=js"
export * from "./AssistantButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports